import React, { useState } from "react";
import {
  FaTachometerAlt,
  FaExclamationCircle,
  FaBars,
  FaTimes,
  FaSignOutAlt,
  FaUserCog,
  FaClipboardList,
  FaUsers,
  FaCreditCard,
  FaUser,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { signOutUser } from "../../Controllers/authController";
import { useUser } from "../AdminDashBoard/UserContext";
import { useSelector } from "react-redux";
const Sidebar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { admin, updateAdmin } = useUser();

  // Get admin status from Redux store
  const user = useSelector((state) => state.auth);
  console.log("User from Redux:", user.userData.isadmin);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = () => {
    updateAdmin(false);
    signOutUser();
    navigate("/login");
  };

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false); // Close menu after navigation
  };

  // Close menu when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuOpen && !event.target.closest('.sidebar-container') && !event.target.closest('.menu-button')) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <>
      {/* Menu Button (Always visible on all screens) */}
      <button
        onClick={toggleMenu}
        className="menu-button fixed top-6 right-6 z-50 text-white bg-[#097573] p-3 rounded-full shadow-lg hover:bg-[#0AD1C8] transition-all duration-300 lg:hidden"
      >
        {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
      </button>

      {/* Sidebar for Large Screens (Always Visible) */}
      <div className="hidden lg:block relative py-4 left-0 top-0  w-64 bg-[#097573] text-white p-6 min-h-screen z-40 shadow-2xl rounded-r-[30px]  sidebar-container">
        <div className="flex flex-col items-center bg-[#09AEA8] rounded-[50px] p-5  mb-8 shadow-2xl">
          <img
            src="/Images/logo.png"
            alt="Aasani Logo"
            className="w-[60%] h-[60%] object-contain mr-3"
          />
          <div className="text-center">
            <h2 className="text-2xl font-bold">Admin Panel</h2>
            <p className="text-teal-100 text-">Management Portal</p>
          </div>
        </div>

        {/* Navigation Links */}
        <nav className="space-y-2 mb-[80%]">
          <button
            className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#0AD1C8] transition-colors duration-200 flex items-center"
            onClick={() => handleNavigate("/admin-dashboard")}
          >
            <FaTachometerAlt className="mr-3" size={16} />
            Dashboard
          </button>
          {/* <button
            className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#0AD1C8] transition-colors duration-200 flex items-center"
            onClick={() => handleNavigate("/notifications")}
          >
            <FaBell className="mr-3" size={16} />
            Notifications
          </button> */}
          <button
            className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#0AD1C8] transition-colors duration-200 flex items-center"
            onClick={() => handleNavigate("/complaints")}
          >
            <FaExclamationCircle className="mr-3" size={16} />
            Complaints
          </button>
          {user?.userData?.isadmin && (
            <button
              className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#0AD1C8] transition-colors duration-200 flex items-center"
              onClick={() => handleNavigate("/admin-management")}
            >
              <FaUserCog className="mr-3" size={16} />
              Admin Management
            </button>
          )}
          <button
            className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#0AD1C8] transition-colors duration-200 flex items-center"
            onClick={() => handleNavigate("/user-management")}
          >
            <FaUsers className="mr-3" size={16} />
            User Management
          </button>
          <button
            className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#0AD1C8] transition-colors duration-200 flex items-center"
            onClick={() => handleNavigate("/posts-page")}
          >
            <FaClipboardList className="mr-3" size={16} />
            Posts
          </button>
          <button
            className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#0AD1C8] transition-colors duration-200 flex items-center"
            onClick={() => handleNavigate("/rides-page")}
          >
            <FaClipboardList className="mr-3" size={16} />
            Rides
          </button>
          <button
            className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#0AD1C8] transition-colors duration-200 flex items-center"
            onClick={() => handleNavigate("/payment-details-page")}
          >
            <FaCreditCard className="mr-3" size={16} />
            Payment Details
          </button>
        </nav>

        {/* User Info & Logout */}
        <div className="absolute bottom-6 left-6 right-6">
          <div className="bg-[#0AD1C8]/20 rounded-lg p-4 mb-4">
            <div className="flex items-center mb-2">
              <div className="w-8 h-8 bg-teal-400 rounded-full flex items-center justify-center mr-3">
                <FaUser size={14} />
              </div>
              <div>
                <p className="text-sm font-medium">{user?.userData.email}</p>
                <p className="text-xs text-teal-100">{user?.userData.isadmin ? "Super Admin" : "Administrator"}</p>
              </div>
            </div>
          </div>
          <button
            className="w-full bg-red-500 text-left py-3 px-4 rounded-lg hover:bg-red-600 transition-colors duration-200 flex items-center"
            onClick={handleLogout}
          >
            <FaSignOutAlt className="mr-3" size={16} />
            Logout
          </button>
        </div>
      </div>

      {/* Centered Popup Sidebar for Small/Medium Screens */}
      {menuOpen && (
        <>
          {/* Backdrop */}
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 lg:hidden" />
          
          {/* Centered Popup */}
          <div className="fixed inset-0 flex items-center justify-center z-50 lg:hidden p-4">
            <div className="sidebar-container bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-hidden animate-in fade-in zoom-in duration-300">
              
              {/* Header */}
              <div className="bg-[#097573] p-6 text-white">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    <img
                      src="/Images/logo.png"
                      alt="Aasani Logo"
                      className="w-10 h-10 object-contain mr-3"
                    />
                    <div>
                      <h2 className="text-xl font-bold">Admin Panel</h2>
                      <p className="text-teal-100 text-sm">Management Portal</p>
                    </div>
                  </div>
                  <button
                    onClick={toggleMenu}
                    className="text-white hover:bg-teal-600 p-2 rounded-lg transition-colors"
                  >
                    <FaTimes size={20} />
                  </button>
                </div>
                
                {/* User Info */}
                <div className="bg-teal-600/30 rounded-lg p-3">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-teal-400 rounded-full flex items-center justify-center mr-3">
                      <FaUser size={16} />
                    </div>
                    <div>
                      <p className="font-medium">{user?.userData.email}</p>
                      <p className="text-sm text-teal-100">{user?.userData.isadmin ? "Super Admin" : "Administrator"}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Navigation Content */}
              <div className="p-6 max-h-[60vh] overflow-y-auto">
                <nav className="space-y-3">
                  <button
                    className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#097573] hover:text-white transition-all duration-200 flex items-center text-gray-700"
                    onClick={() => handleNavigate("/admin-dashboard")}
                  >
                    <FaTachometerAlt className="mr-3 text-[#097573]" size={16} />
                    Dashboard
                  </button>
                  {/* <button
                    className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#097573] hover:text-white transition-all duration-200 flex items-center text-gray-700"
                    onClick={() => handleNavigate("/notifications")}
                  >
                    <FaBell className="mr-3 text-[#097573]" size={16} />
                    Notifications
                  </button> */}
                  <button
                    className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#097573] hover:text-white transition-all duration-200 flex items-center text-gray-700"
                    onClick={() => handleNavigate("/complaints")}
                  >
                    <FaExclamationCircle className="mr-3 text-[#097573]" size={16} />
                    Complaints
                  </button>
                  {admin && (
                    <button
                      className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#097573] hover:text-white transition-all duration-200 flex items-center text-gray-700"
                      onClick={() => handleNavigate("/admin-management")}
                    >
                      <FaUserCog className="mr-3 text-[#097573]" size={16} />
                      Admin Management
                    </button>
                  )}
                  <button
                    className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#097573] hover:text-white transition-all duration-200 flex items-center text-gray-700"
                    onClick={() => handleNavigate("/user-management")}
                  >
                    <FaUsers className="mr-3 text-[#097573]" size={16} />
                    User Management
                  </button>
                  <button
                    className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#097573] hover:text-white transition-all duration-200 flex items-center text-gray-700"
                    onClick={() => handleNavigate("/posts-page")}
                  >
                    <FaClipboardList className="mr-3 text-[#097573]" size={16} />
                    Posts
                  </button>
                  <button
                    className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#097573] hover:text-white transition-all duration-200 flex items-center text-gray-700"
                    onClick={() => handleNavigate("/rides-page")}
                  >
                    <FaClipboardList className="mr-3 text-[#097573]" size={16} />
                    Rides
                  </button>
                  <button
                    className="w-full text-left py-3 px-4 rounded-lg hover:bg-[#097573] hover:text-white transition-all duration-200 flex items-center text-gray-700"
                    onClick={() => handleNavigate("/payment-details-page")}
                  >
                    <FaCreditCard className="mr-3 text-[#097573]" size={16} />
                    Payment Details
                  </button>
                </nav>
              </div>

              {/* Footer with Logout */}
              <div className="p-6 border-t border-gray-200">
                <button
                  className="w-full bg-red-500 text-white py-3 px-4 rounded-lg hover:bg-red-600 transition-colors duration-200 flex items-center justify-center"
                  onClick={handleLogout}
                >
                  <FaSignOutAlt className="mr-3" size={16} />
                  Logout
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Sidebar;